export default __webpack_public_path__ + "static/media/teacher-win.99404fb2.png";